import React, { useEffect, useMemo, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useParams } from 'react-router-dom';
import Topbar from '../../PulseSurvey/Topbar';
import Breadcrumb from '../../../component/common/Breadcrumb';
import { Api } from '../../../api';

export default function KidsView() {
  const { id } = useParams();
  const [kidData, setKidData] = useState(null);

  useEffect(() => {
    async function fetchKid() {
      if (id) {
        try {
          const response = await Api.getKidById(id);
          console.log(response);
          setKidData(response?.data?.data);
        } catch (error) {
          setKidData(null);
        }
      }
    }
    fetchKid();
  }, [id]);

  const initials = useMemo(() => {
    if (!kidData?.name) return '';
    const parts = kidData.name.trim().split(' ');
    const first = parts[0]?.[0] || '';
    const second = parts[1]?.[0] || '';
    return (first + second).toUpperCase();
  }, [kidData?.name]);

  const statusPill = (status) => (
    <span
      className={`px-3 py-1 rounded-2xl text-xs font-semibold ${
        status === 1 ? 'bg-green-100 text-green-600' : 'bg-red-100 text-red-600'
      }`}
    >
      {status === 1 ? 'Active' : 'Inactive'}
    </span>
  );

  const fieldRow = (label, value) => (
    <div className="flex items-center justify-between py-3 border-[1px] border-solid p-2">
      <dd className="text-base font-medium text-gray-500">{label}</dd>
      <dt className="mt-1 text-base dark:text-white text-gray-900 sm:col-span-2 sm:mt-0 capitalize">
        {value ?? '-'}
      </dt>
    </div>
  );

  return (
    <div className="relative lg:mb-[45px]">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Kids | Shoorah Admin</title>
      </Helmet>
      <Topbar title={'Kids'} />
      <Breadcrumb pageList={5} className="lg:mt-8" />
      {kidData && (
        <div className="mt-4 grid grid-cols-1 lg:grid-cols-2 gap-4">
          {/* Left: Profile and Details */}
          <div className="bg-white dark:bg-shoorah-darkBgTabColor dark:text-white rounded-lg shadow p-6">
            <div className="flex items-center gap-4">
              <div className="bg-gray-200 text-gray-700 flex items-center justify-center h-20 w-20 rounded-full text-xl font-semibold">
                {initials || 'K'}
              </div>
              <div className="flex-1">
                <p className="text-lg font-semibold capitalize">{kidData.name}</p>
                <div className="mt-1">{statusPill(kidData.status)}</div>
              </div>
            </div>
            <div className="mt-6 ">
              {fieldRow('Age', kidData.age)}
              {fieldRow('DOB', kidData.dob ? new Date(kidData.dob).toLocaleDateString() : '-')}
              {/* {fieldRow(
                'Gender',
                kidData.gender === 1 ? 'Male' : kidData.gender === 2 ? 'Female' : 'Other'
              )}
              {fieldRow('Ethnicity', kidData.ethnicity || '-')}
              {fieldRow('Disability', kidData.disability === 'true' ? 'Yes' : 'No')} */}
              {fieldRow(
                'Last Login',
                kidData.last_login ? new Date(kidData.last_login).toLocaleString() : '-'
              )}
              {fieldRow(
                'Created At',
                kidData.createdAt ? new Date(kidData.createdAt).toLocaleString() : '-'
              )}
              {fieldRow(
                'Updated At',
                kidData.updatedAt ? new Date(kidData.updatedAt).toLocaleString() : '-'
              )}
              {fieldRow('Parent Name', kidData.parent_name || '-')}
              {fieldRow('Parent Email', kidData.parent_email || '-')}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
